export const heroData = {
  tag: "免费在线看大片",
  h1: "天堂影院 · 高清不缓冲 流畅在线观影平台",
  slogan: "蓝光画质 观影不卡顿 无广告影视 极速播放",
  description: "天堂影院致力于为影迷打造极致的在线观影体验。平台汇聚海量高清影视资源，涵盖动作、喜剧、科幻、悬疑、爱情、动画等全品类电影大全，支持蓝光画质流畅播放。每日更新最新院线大片与经典佳作，全站无弹窗广告干扰，打开即看，无需等待缓冲。无论你是电影爱好者还是追剧达人，天堂影院都能让你享受到纯净、高速、高品质的高清影视在线播放服务。",
  stats: [
    { label: "高清片源", value: "10万+" },
    { label: "每日更新", value: "50+部" },
    { label: "播放线路", value: "多线备选" },
  ],
  primaryCta: { text: "立即观影", href: "#carousel" },
  secondaryCta: { text: "热门排行", href: "#ranking" },
};

export const carouselData = [
  {
    id: 1,
    tag: "动作大片",
    title: "极限追凶：暗夜行动",
    description: "国际刑警联手破解跨国犯罪集团惊天阴谋，全程高能打斗肾上腺素飙升",
    image: "https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20intense%20urban%20night%20chase%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20city%20streets%20with%20neon%20reflections%2C%20high%20contrast%20photography%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20movie%20poster%20aesthetic%2C%20professional%20cinematography%20style&width=800&height=560&seq=carousel-01&orientation=landscape",
    link: "#carousel",
  },
  {
    id: 2,
    tag: "科幻巨制",
    title: "星际迷航：新纪元",
    description: "人类探索未知星域遭遇神秘文明，视觉特效震撼呈现浩瀚宇宙奇观",
    image: "https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20scene%20vast%20spaceship%20approaching%20mysterious%20alien%20planet%2C%20nebula%20clouds%20in%20deep%20space%2C%20dramatic%20cinematic%20lighting%2C%20warm%20golden%20and%20deep%20blue%20contrast%2C%20epic%20scale%2C%20movie%20poster%20quality%2C%20professional%20cinematography&width=800&height=560&seq=carousel-02&orientation=landscape",
    link: "#carousel",
  },
  {
    id: 3,
    tag: "悬疑惊悚",
    title: "密室逃脱：生死倒计时",
    description: "六名陌生人被困密闭空间，必须在72小时内破解层层谜题找出幕后真凶",
    image: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20scene%20dimly%20lit%20mysterious%20room%20with%20shadows%20and%20cryptic%20clues%2C%20tense%20atmosphere%2C%20warm%20amber%20light%20through%20cracks%2C%20cinematic%20composition%2C%20dark%20and%20moody%20aesthetic%2C%20film%20poster%20style&width=800&height=560&seq=carousel-03&orientation=landscape",
    link: "#carousel",
  },
  {
    id: 4,
    tag: "喜剧温情",
    title: "老爸当家：爆笑假期",
    description: "单亲爸爸带娃旅行笑料百出，温馨治愈喜剧让你笑中带泪感动满满",
    image: "https://readdy.ai/api/search-image?query=Warm%20comedy%20movie%20scene%20father%20and%20child%20on%20road%20trip%20sunny%20countryside%2C%20golden%20hour%20lighting%2C%20joyful%20and%20heartwarming%20atmosphere%2C%20cinematic%20composition%2C%20bright%20warm%20tones%2C%20film%20poster%20aesthetic&width=800&height=560&seq=carousel-04&orientation=landscape",
    link: "#carousel",
  },
  {
    id: 5,
    tag: "动画奇幻",
    title: "龙族传说：觉醒之力",
    description: "少年与上古神龙缔结契约，踏上守护世界的奇幻冒险旅程画面绝美",
    image: "https://readdy.ai/api/search-image?query=Epic%20animated%20fantasy%20movie%20scene%20young%20hero%20with%20a%20majestic%20dragon%20in%20misty%20mountains%2C%20magical%20atmosphere%2C%20warm%20golden%20and%20emerald%20tones%2C%20cinematic%20composition%2C%20stunning%20visuals%2C%20movie%20poster%20quality&width=800&height=560&seq=carousel-05&orientation=landscape",
    link: "#carousel",
  },
  {
    id: 6,
    tag: "爱情文艺",
    title: "遇见你之前：时光倒流",
    description: "跨越时空的爱恋感动万千观众，唯美画面诠释最动人的相遇与别离",
    image: "https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20couple%20walking%20through%20cherry%20blossom%20path%20at%20sunset%2C%20soft%20warm%20golden%20light%2C%20dreamy%20bokeh%20effect%2C%20cinematic%20composition%2C%20tender%20and%20nostalgic%20atmosphere%2C%20film%20poster%20aesthetic&width=800&height=560&seq=carousel-06&orientation=landscape",
    link: "#carousel",
  },
];

export const updatesData = [
  { id: 1, date: "07-30", tag: "新片上线", title: "《星际迷航：新纪元》蓝光高清版已上线，支持多线路切换播放", link: "#updates" },
  { id: 2, date: "07-29", tag: "片源更新", title: "动作大片《极限追凶》新增导演剪辑版，增加30分钟未公开片段", link: "#updates" },
  { id: 3, date: "07-28", tag: "系统公告", title: "全站播放线路全面升级，新增H265编码支持，画质更清晰流量更节省", link: "#updates" },
  { id: 4, date: "07-27", tag: "热门推荐", title: "《密室逃脱》系列三部曲合集上线，一口气看完整部悬疑巨作", link: "#updates" },
  { id: 5, date: "07-26", tag: "新片上线", title: "国产动画《龙族传说：觉醒之力》口碑爆棚，豆瓣开分8.7", link: "#updates" },
  { id: 6, date: "07-25", tag: "专题策划", title: "「夏日影院」专题上线，精选50部适合夏天看的清凉好片", link: "#updates" },
  { id: 7, date: "07-24", tag: "片源更新", title: "经典修复版《遇见你之前》4K重制上线，重温感动瞬间", link: "#updates" },
];

export const contactData = {
  title: "联系我们",
  subtitle: "有想看的片子？有观影问题？欢迎随时联系天堂影院团队",
  description: "天堂影院始终坚持用户至上的服务理念。如果您在使用过程中遇到任何播放问题，或者有想看的影片推荐给我们，欢迎通过以下方式联系我们。我们的内容团队会认真对待每一条反馈，努力为您提供更优质的高清影视在线播放体验。",
  email: "feedback@tiantangcinema.com",
  wechat: "tiantangcinema",
  qq: "88886666",
};

export const mediaData = [
  {
    id: 1,
    title: "《极限追凶》终极预告 - 暗夜行动即将展开",
    image: "https://readdy.ai/api/search-image?query=Action%20movie%20trailer%20thumbnail%20urban%20night%20scene%20with%20dramatic%20car%20chase%2C%20explosive%20lighting%20effects%2C%20cinematic%20wide%20shot%2C%20warm%20amber%20and%20dark%20tones%2C%20video%20player%20interface%20overlay%2C%20professional%20movie%20promotional%20style&width=640&height=360&seq=media-01&orientation=landscape",
    duration: "02:35",
    views: "128.6万",
    category: "动作",
  },
  {
    id: 2,
    title: "《龙族传说》幕后特辑 - 揭秘动画制作全过程",
    image: "https://readdy.ai/api/search-image?query=Animation%20movie%20behind%20the%20scenes%20thumbnail%20artist%20working%20on%20character%20design%2C%20warm%20studio%20lighting%2C%20creative%20workspace%2C%20cinematic%20composition%2C%20professional%20film%20production%20style&width=640&height=360&seq=media-02&orientation=landscape",
    duration: "05:18",
    views: "89.3万",
    category: "幕后",
  },
  {
    id: 3,
    title: "《密室逃脱》导演访谈 - 悬疑片创作的艺术",
    image: "https://readdy.ai/api/search-image?query=Film%20director%20interview%20scene%20dim%20atmospheric%20lighting%2C%20cinematic%20setup%20with%20warm%20key%20light%2C%20professional%20interview%20setting%2C%20dark%20moody%20background%2C%20film%20industry%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape",
    duration: "08:42",
    views: "56.7万",
    category: "访谈",
  },
  {
    id: 4,
    title: "《老爸当家》搞笑片段合集 - 笑到停不下来",
    image: "https://readdy.ai/api/search-image?query=Comedy%20movie%20highlight%20thumbnail%20funny%20family%20scene%20bright%20sunny%20day%2C%20warm%20golden%20lighting%2C%20joyful%20expressions%2C%20cinematic%20composition%2C%20lighthearted%20and%20fun%20atmosphere&width=640&height=360&seq=media-04&orientation=landscape",
    duration: "03:51",
    views: "215.2万",
    category: "搞笑",
  },
  {
    id: 5,
    title: "《星际迷航》视效解析 - 如何打造震撼宇宙场景",
    image: "https://readdy.ai/api/search-image?query=Visual%20effects%20breakdown%20thumbnail%20spaceship%20and%20nebula%20rendering%2C%20technical%20studio%20environment%2C%20warm%20monitor%20glow%2C%20cinematic%20composition%2C%20professional%20VFX%20production%20aesthetic&width=640&height=360&seq=media-05&orientation=landscape",
    duration: "06:14",
    views: "73.9万",
    category: "特效",
  },
];

export const aboutData = {
  title: "关于天堂影院",
  paragraphs: [
    "天堂影院是一个专注于高清影视在线播放的综合性观影平台。自成立以来，我们始终秉持\"高清不缓冲、流畅在线观看\"的核心服务理念，致力于为广大影迷提供极致的在线观影体验。平台汇聚了涵盖动作、喜剧、科幻、悬疑、爱情、动画、纪录片等全品类电影大全资源，无论是院线热映大片还是经典老片，你都能在天堂影院找到。",
    "在技术层面，天堂影院采用先进的视频编码和CDN加速技术，确保蓝光画质下的极速播放体验。平台支持多线路智能切换，当某条线路出现波动时自动切换备用线路，真正实现观影不卡顿。我们深知广告对观影体验的破坏，因此全站承诺无弹窗广告、无片头广告，让每一位用户都能沉浸在纯净的观影环境中。",
    "天堂影院的内容团队每日精心筛选优质片源，保证每天50部以上的更新频率。从热门大片到小众佳作，从经典修复到独家专题，我们用心的内容运营确保每位影迷都能在这里发现属于自己的好电影。未来，天堂影院将持续优化播放体验，丰富内容库，打造华语地区最值得信赖的高清影视在线播放平台。",
  ],
  stats: [
    { value: "100,000+", label: "高清片源" },
    { value: "50+", label: "日更新量" },
    { value: "99.9%", label: "播放成功率" },
  ],
};

export const rankingData = [
  {
    id: 1,
    rank: 1,
    title: "极限追凶：暗夜行动",
    category: "动作 / 犯罪",
    score: "9.2",
    heat: "本周播放量 586.3万",
    image: "https://readdy.ai/api/search-image?query=Action%20crime%20movie%20poster%20dark%20urban%20night%20aesthetic%2C%20dramatic%20portrait%20of%20detective%2C%20warm%20neon%20accents%2C%20cinematic%20composition%2C%20professional%20movie%20poster%20style%2C%20clean%20background&width=200&height=280&seq=ranking-01&orientation=portrait",
  },
  {
    id: 2,
    rank: 2,
    title: "龙族传说：觉醒之力",
    category: "动画 / 奇幻",
    score: "8.9",
    heat: "本周播放量 472.1万",
    image: "https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20young%20hero%20with%20dragon%2C%20magical%20atmosphere%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20professional%20animation%20poster%20style%2C%20clean%20background&width=200&height=280&seq=ranking-02&orientation=portrait",
  },
  {
    id: 3,
    rank: 3,
    title: "密室逃脱：生死倒计时",
    category: "悬疑 / 惊悚",
    score: "8.7",
    heat: "本周播放量 398.5万",
    image: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20dark%20room%20with%20mysterious%20light%2C%20tense%20atmosphere%2C%20warm%20amber%20key%20light%2C%20cinematic%20composition%2C%20professional%20movie%20poster%20style%2C%20clean%20background&width=200&height=280&seq=ranking-03&orientation=portrait",
  },
  {
    id: 4,
    rank: 4,
    title: "星际迷航：新纪元",
    category: "科幻 / 冒险",
    score: "8.5",
    heat: "本周播放量 356.8万",
    image: "https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20astronaut%20in%20space%20with%20nebula%2C%20epic%20cosmic%20atmosphere%2C%20warm%20and%20cool%20contrast%2C%20cinematic%20composition%2C%20professional%20movie%20poster%20style%2C%20clean%20background&width=200&height=280&seq=ranking-04&orientation=portrait",
  },
  {
    id: 5,
    rank: 5,
    title: "遇见你之前：时光倒流",
    category: "爱情 / 文艺",
    score: "8.3",
    heat: "本周播放量 289.7万",
    image: "https://readdy.ai/api/search-image?query=Romantic%20movie%20poster%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20warm%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20professional%20movie%20poster%20style%2C%20clean%20background&width=200&height=280&seq=ranking-05&orientation=portrait",
  },
];

export const faqData = [
  {
    id: 1,
    question: "天堂影院的视频播放需要安装插件吗？",
    answer: "完全不需要。天堂影院采用HTML5播放器技术，支持所有主流浏览器（Chrome、Edge、Safari、Firefox等），打开网页即可播放，无需下载或安装任何插件。无论是电脑端还是手机端，都能享受到流畅的观影体验。",
  },
  {
    id: 2,
    question: "为什么有些影片播放时会出现卡顿？如何解决？",
    answer: "天堂影院为每部影片配置了多条播放线路。如遇卡顿，请点击播放器下方的\"切换线路\"按钮，系统会自动切换到最流畅的线路。建议优先选择标注\"推荐\"或\"极速\"的线路。同时请确保网络连接稳定，建议使用WiFi或5G网络获得最佳的高清不缓冲体验。",
  },
  {
    id: 3,
    question: "天堂影院真的完全免费且没有广告吗？",
    answer: "是的。天堂影院全站承诺永久免费，不收取任何费用，也无需注册会员即可观看所有内容。更重要的是，我们严格杜绝弹窗广告、片头广告和插屏广告，确保观影过程纯净无干扰。这是天堂影院区别于其他平台的核心优势之一。",
  },
  {
    id: 4,
    question: "影片的画质可以达到什么级别？支持蓝光吗？",
    answer: "天堂影院提供从标清到蓝光的多级画质选项，最高支持1080P蓝光画质。部分热门影片还提供4K超清版本。您可以在播放器右下角的\"画质\"菜单中选择适合您网络环境的清晰度。建议在高速网络下选择蓝光模式，享受极致的视觉体验。",
  },
  {
    id: 5,
    question: "我想看的影片平台上没有怎么办？",
    answer: "您可以通过页面底部的\"联系我们\"渠道向我们反馈想看的影片名称。天堂影院的内容团队会根据用户反馈的热度优先安排片源更新。通常情况下，热门反馈的影片会在3-5个工作日内完成上线。",
  },
];

export const featuresData = [
  {
    id: 1,
    icon: "ri-movie-2-line",
    title: "海量片源 每日更新",
    description: "超10万部高清影视资源，每日50+部新片持续更新，覆盖全品类电影大全，你想看的这里都有。",
  },
  {
    id: 2,
    icon: "ri-speed-up-line",
    title: "极速播放 高清不缓冲",
    description: "自建CDN加速网络配合多线智能切换，确保蓝光画质下依然流畅在线观看，观影不卡顿。",
  },
  {
    id: 3,
    icon: "ri-advertisement-line",
    title: "纯净观影 无广告干扰",
    description: "全站零广告承诺，无弹窗、无片头广告、无插屏干扰，给你最纯净的高清影视在线播放体验。",
  },
  {
    id: 4,
    icon: "ri-device-line",
    title: "全端适配 随时随地看",
    description: "电脑、平板、手机全终端完美适配，无需安装APP即可在浏览器中获得一致的高品质观影体验。",
  },
];

export const commentsData = [
  {
    id: 1,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20simple%20background%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-01&orientation=squarish",
    name: "电影爱好者小李",
    date: "2026-07-28",
    rating: 5,
    content: "天堂影院真的太良心了！画质清晰不卡顿，而且真的没有广告，看一部电影从头到尾干干净净。之前用其他平台总是被弹窗广告烦死，现在只在天堂影院看片。蓝光画质配合极速播放，体验感拉满！",
  },
  {
    id: 2,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20warm%20natural%20lighting%2C%20gentle%20smile%2C%20clean%20simple%20background%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-02&orientation=squarish",
    name: "追剧达人小王",
    date: "2026-07-27",
    rating: 5,
    content: "更新速度超级快！刚上映的大片这边就能看了，片源还特别全。最喜欢多线路切换功能，一条线路卡了切另一条马上流畅。高清在线播放的质量真的没话说，已经安利给身边所有朋友了。",
  },
  {
    id: 3,
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle%20aged%20Chinese%20man%2C%20warm%20natural%20lighting%2C%20confident%20expression%2C%20clean%20simple%20background%2C%20professional%20photography&width=80&height=80&seq=comment-avatar-03&orientation=squarish",
    name: "资深影评人老张",
    date: "2026-07-26",
    rating: 5,
    content: "作为一个阅片无数的老影迷，天堂影院的片库深度确实让人惊喜。不仅有最新大片，很多小众文艺片和经典修复版都能找到。蓝光画质配合流畅的播放体验，让我重新找回了沉浸式观影的乐趣。无广告这一点尤其加分。",
  },
];

export const indexData = [
  { id: 1, title: "动作大片", count: "2,856部", icon: "ri-fire-line", link: "#index" },
  { id: 2, title: "喜剧天地", count: "1,934部", icon: "ri-emotion-laugh-line", link: "#index" },
  { id: 3, title: "科幻巨制", count: "1,247部", icon: "ri-rocket-line", link: "#index" },
  { id: 4, title: "悬疑烧脑", count: "1,589部", icon: "ri-search-eye-line", link: "#index" },
  { id: 5, title: "爱情文艺", count: "2,103部", icon: "ri-heart-line", link: "#index" },
  { id: 6, title: "动画世界", count: "1,876部", icon: "ri-palette-line", link: "#index" },
  { id: 7, title: "纪录纪实", count: "945部", icon: "ri-film-line", link: "#index" },
];

export const topicsData = [
  { id: 1, name: "2026暑期档", count: "326", hot: true },
  { id: 2, name: "国产动画崛起", count: "198", hot: true },
  { id: 3, name: "悬疑片推荐", count: "275", hot: true },
  { id: 4, name: "蓝光合集", count: "512", hot: false },
  { id: 5, name: "经典修复版", count: "189", hot: false },
  { id: 6, name: "DC宇宙", count: "156", hot: false },
  { id: 7, name: "漫威系列", count: "203", hot: true },
  { id: 8, name: "韩国电影", count: "467", hot: false },
  { id: 9, name: "日本动画", count: "638", hot: true },
  { id: 10, name: "奥斯卡获奖", count: "128", hot: false },
  { id: 11, name: "独立电影", count: "341", hot: false },
];

export const appData = {
  title: "随时随地 高清观影",
  subtitle: "天堂影院完美适配手机浏览器，无需下载APP",
  description: "在手机浏览器中打开天堂影院，即可享受与电脑端一致的高清影视在线播放体验。自适应布局、触控优化、流量节省模式，让你在地铁、午休、旅途中随时畅享大片。",
  features: ["无需安装 即开即看", "流量智能优化", "触控手势适配", "夜间模式护眼"],
};

export const cardsData = [
  {
    id: 1,
    title: "暑期档必看：十部高分大片推荐",
    description: "精选今年暑期档口碑最好的十部电影，从动作到喜剧，部部精彩不容错过。天堂影院已全部上线蓝光版本。",
    image: "https://readdy.ai/api/search-image?query=Summer%20movie%20collection%20collage%20cinematic%20posters%20warm%20vibrant%20colors%2C%20golden%20sunlight%2C%20entertainment%20theme%2C%20professional%20layout%2C%20clean%20modern%20design%2C%20movie%20festival%20aesthetic&width=400&height=300&seq=cards-01&orientation=landscape",
    tag: "专题策划",
    category: "合集推荐",
  },
  {
    id: 2,
    title: "国产动画崛起：从大圣到龙族的高光时刻",
    description: "盘点近年来国产动画电影的里程碑之作，见证中国动画从技术到叙事的全面飞跃。",
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20highlights%20artistic%20composition%2C%20traditional%20and%20modern%20fusion%20style%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20aesthetic%2C%20clean%20design%20layout&width=400&height=300&seq=cards-02&orientation=landscape",
    tag: "深度盘点",
    category: "行业观察",
  },
  {
    id: 3,
    title: "悬疑片爱好者的终极片单：从入门到精通",
    description: "从经典悬疑到心理惊悚，一份覆盖不同难度层级的悬疑片观影指南。",
    image: "https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20collection%20dark%20atmospheric%20composition%2C%20dramatic%20shadows%20and%20warm%20amber%20highlights%2C%20cinematic%20aesthetic%2C%20clean%20layout%20design&width=400&height=300&seq=cards-03&orientation=landscape",
    tag: "观影指南",
    category: "片单推荐",
  },
  {
    id: 4,
    title: "蓝光画质体验升级：这些细节你注意到了吗",
    description: "蓝光画质下才能看清的电影细节，从服装纹理到场景设计，发现被忽略的视觉美感。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20film%20detail%20close%20up%20texture%20and%20lighting%2C%20warm%20professional%20lighting%2C%20high%20definition%20quality%2C%20cinematic%20composition%2C%20clean%20modern%20design&width=400&height=300&seq=cards-04&orientation=landscape",
    tag: "技术解析",
    category: "观影技巧",
  },
  {
    id: 5,
    title: "那些被低估的科幻佳作：冷门但惊艳",
    description: "不是所有好科幻都上过头条。这十部冷门科幻片虽然知名度不高，但创意和完成度绝不输大片。",
    image: "https://readdy.ai/api/search-image?query=Underrated%20science%20fiction%20movies%20artistic%20composition%2C%20futuristic%20but%20subtle%20aesthetic%2C%20warm%20ambient%20lighting%2C%20cinematic%20style%2C%20clean%20design%20layout&width=400&height=300&seq=cards-05&orientation=landscape",
    tag: "冷门精选",
    category: "片单推荐",
  },
  {
    id: 6,
    title: "从龙族传说看中国奇幻电影的特效进阶之路",
    description: "《龙族传说》的视觉奇观背后，是中国特效团队十余年的技术积累与艺术探索。",
    image: "https://readdy.ai/api/search-image?query=Visual%20effects%20evolution%20Chinese%20fantasy%20film%20artistic%20comparison%2C%20warm%20cinematic%20lighting%2C%20professional%20composition%2C%20modern%20clean%20design%20layout&width=400&height=300&seq=cards-06&orientation=landscape",
    tag: "行业分析",
    category: "深度解读",
  },
  {
    id: 7,
    title: "2026上半年华语电影票房TOP20一览",
    description: "数据盘点2026上半年最卖座的华语电影，看看你贡献了几张票？多部已上线天堂影院。",
    image: "https://readdy.ai/api/search-image?query=Movie%20box%20office%20chart%20cinematic%20visualization%2C%20warm%20golden%20data%20aesthetic%2C%20professional%20design%20layout%2C%20clean%20modern%20style%2C%20entertainment%20industry%20theme&width=400&height=300&seq=cards-07&orientation=landscape",
    tag: "数据盘点",
    category: "票房分析",
  },
];

export const footerData = {
  description: "天堂影院 - 高清不缓冲流畅在线观看平台。汇聚海量电影大全，提供蓝光画质极速播放体验，全站无广告免费在线看大片。每日更新50+部高清影视资源，让每一位影迷都能享受纯净的观影乐趣。",
};